import { API_ROUTES, createQueryKey } from '@shared/api-utils';
import type { QueryClient } from '@tanstack/react-query';

function invalidateMyAccountVerificationQueries(queryClient: QueryClient) {
  void queryClient.invalidateQueries({ queryKey: createQueryKey(API_ROUTES.PLAYER_KYC.VERIFICATION.KYC_CARD) });
}

export { invalidateMyAccountVerificationQueries };
